export const statuses = {
  pending: 'Pendente',
  consolidated: 'Consolidado',
  paid: 'Pago',
};

export const icons = {
  pending: 'clock',
  consolidated: 'file-invoice-dollar',
  paid: 'check-circle',
};

export function getName(value) {
  return statuses[value];
}
